import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export const StickyCTA = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  const hidden = pathname === "/quiz" || pathname === "/contact";

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 650);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (hidden) return null;
  return (
    <div className={`sticky-cta${show ? " show" : ""}`} data-testid="sticky-cta">
      <Link to="/#join">Join Dialed In</Link>
    </div>
  );
};
